import React, { Component } from 'react';
import { Platform } from 'react-native';

import { isFunction as _isFunction, isNil as _isNil } from 'lodash';
import PropTypes from 'prop-types';

import {
  VFScreen,
  HeaderTabs,
  TabView,
  VFButton,
  Shimmer,
} from '@vfgroup-oneplatform/foundation/Components';
import ManualRefresh from '@vfgroup-oneplatform/foundation/Components/ManualRefresh';
import { withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';
import { User_Types } from '@vfgroup-oneplatform/foundation/Utils/UserTypes.Enum';

import FrameworkTestKeys from '../FrameworkTestKeys';
import { ProductsAndServicesTrackingManager } from '../Utils/TrackingManagers';

import { ProductsAndServicesTab } from './Components';
import Deprecated_ProductsAndServices from './Deprecated_ProductsAndServices';
import styles from './ProductsAndServices.Styles';
import {
  headerFirstLineLoadingConfig,
  shimmerPlaceholderConfig,
} from './ProductsAndServicesConfig';

class ProductsAndServices extends Component {
  constructor(props) {
    super(props);
    this.HeaderTabsProps = this.getHeaderTabsProps();
    this.state = {
      activeTab: 0,
    };
  }

  componentDidMount() {
    const { activeTab } = this.state;
    ProductsAndServicesTrackingManager.trackView();
    this.onActiveTabChange(activeTab);
  }

  onActiveTabChange = activeTab => {
    const { onActiveTabChange } = this.props;
    this.setState({
      activeTab,
    });
    if (_isFunction(onActiveTabChange)) {
      onActiveTabChange(activeTab, this.HeaderTabsProps[activeTab]);
    }
  };
  getHeaderTabsProps = () => {
    const { tabs } = this.props;
    const filteredTabs = this.filterTabsPerPlatform(tabs);
    const sortedTabs = filteredTabs.sort((a, b) => a.index - b.index);
    return sortedTabs.map((tab, index) => ({
      ...tab,
      index,
    }));
  };

  filterTabsPerPlatform = tabs => {
    return tabs.filter(tab => {
      return _isNil(tab.platform) || tab.platform === Platform.OS;
    });
  };

  renderDescription = () => {
    const { images, onRefresh, lastUpdateTime } = this.props;
    return (
      <ManualRefresh
        onRefresh={onRefresh}
        images={images}
        iconName="ic_bold_small_refresh"
        lastUpdateTime={lastUpdateTime}
        containerStyle={styles.manualRefreshContainerStyle}
      />
    );
  };

  renderTabsContent = () => {
    // DEPRECATEME: since [Release 22]
    const { pageBannerProps, withPageBanner, autoTopUpBannerProps } = this.props;
    const oldProps = ['pageBannerProps', 'withPageBanner', 'autoTopUpBannerProps'].filter(prop =>
      Object.keys(this.props).includes(prop),
    );

    if (oldProps.length > 0) {
      console.warn(
        oldProps
          .map(
            prop =>
              `"${prop}" is deprecated and will no longer be supported in future releases, You can instead render <VFBanner> inside 'renderTabContent' func in 'tabs' prop. \n for more details visit https://github.vodafone.com/pages/VFGroup-MyVodafone-OnePlatform/Documentation/React%20Native/Framework/Products%20and%20services`,
          )
          .join('\n \n'),
      );

      return this.HeaderTabsProps.map(({ index, key, renderTabContent }) => (
        <TabView index={index} key={key}>
          <ProductsAndServicesTab
            TabComponent={renderTabContent}
            pageBannerProps={pageBannerProps}
            withPageBanner={withPageBanner}
            autoTopUpBannerProps={autoTopUpBannerProps}
          />
        </TabView>
      ));
    }
    // End deprecation

    return this.HeaderTabsProps.map(({ index, key, renderTabContent }) => (
      <TabView index={index} key={key}>
        {renderTabContent()}
      </TabView>
    ));
  };

  renderSubHeaderRightComponent = () => {
    const { vfScreenProps, topUpProps } = this.props;
    const { renderSubHeaderRightComponent } = vfScreenProps;
    if (_isFunction(renderSubHeaderRightComponent)) {
      return renderSubHeaderRightComponent();
    }
    const { onTopUpButtonPress, toggleModal } = topUpProps;
    return (
      <VFButton
        title={'my_products_header_payg_topup_button_title'}
        onPress={_isFunction(onTopUpButtonPress) ? onTopUpButtonPress : toggleModal}
        style={styles.subHeaderRightComponent}
        textStyle={styles.subHeaderRightComponentStyle}
        testKey={FrameworkTestKeys.MyProductsHeaderPaygTopupButtonTitleLabelProductsAndServices}
        type={'primary'}
      />
    );
  };
  renderHeaderShimmer = () => {
    const { isHeaderLoading, headerShimmerConfig, headerShimmerPlaceholderConfig } = this.props;
    if (isHeaderLoading) {
      return (
        <Shimmer
          config={headerShimmerConfig ?? headerFirstLineLoadingConfig}
          shimmerPlaceholderConfig={headerShimmerPlaceholderConfig ?? shimmerPlaceholderConfig}
        />
      );
    }
  };

  render() {
    const { vfScreenProps, userType, renderTopUp, isScrollEnabled, withTabsScroll } = this.props;
    const { activeTab } = this.state;

    // DEPRECATEME: since [Release 21]
    const oldProps = [
      'myPlanProps',
      'devicesProps',
      'addOnsProps',
      'balanceProps',
      'customTabs',
    ].filter(prop => Object.keys(this.props).includes(prop));

    if (oldProps.length > 0) {
      console.warn(
        oldProps
          .map(
            prop =>
              `"${prop}" is deprecated and will no longer be supported in future releases, Please use "tabs" instead. \n for more details visit https://github.vodafone.com/pages/VFGroup-MyVodafone-OnePlatform/Documentation/React%20Native/Framework/Products%20and%20services`,
          )
          .join('\n \n'),
      );

      return <Deprecated_ProductsAndServices {...this.props} />;
    }
    /* End deprecation */

    return (
      <VFScreen
        withHeaderSpace
        renderDescriptionInfo={this.renderDescription}
        renderSubHeaderRightComponent={
          userType === User_Types.PAY_G ? this.renderSubHeaderRightComponent : null
        }
        {...vfScreenProps}
        configureHeaderTabs={{
          withTabsScroll: withTabsScroll,
          activeTab,
          setActiveTab: this.onActiveTabChange,
          tabs: this.HeaderTabsProps?.length > 1 ? this.HeaderTabsProps : null,
          scrollEnabled: isScrollEnabled,
        }}
        containerStyle={styles.ScreenContainer}
        subHeaderDescriptionContainerStyle={styles.subHeaderDescriptionContainer}
        headerStyle={styles.headerStyle}
        subHeaderMaxHeight={Platform.OS === 'ios' ? 105 : 112}
        customHeaderContent={this.renderHeaderShimmer()}
      >
        <HeaderTabs activeTab={activeTab}>{this.renderTabsContent()}</HeaderTabs>
        {renderTopUp()}
      </VFScreen>
    );
  }
}

ProductsAndServices.defaultProps = {
  tabs: [],
  userType: User_Types.PAY_M,
  refreshIcon: 'ic_refresh',
  isScrollEnabled: true,
  withTabsScroll: false,
  isHeaderLoading: false,
};

ProductsAndServices.propTypes = {
  userType: PropTypes.oneOf(Object.values(User_Types)),
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      index: PropTypes.number,
      key: PropTypes.string.isRequired,
      tab_key: PropTypes.string.isRequired,
      renderTabContent: PropTypes.func.isRequired,
      platform: PropTypes.oneOf('android', 'ios'),
    }),
  ),
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  withTray: PropTypes.bool,
  images: PropTypes.object,
  headerDescription: PropTypes.string,
  onActiveTabChange: PropTypes.func,
  refreshIcon: PropTypes.string,
  vfScreenProps: PropTypes.shape({
    title: PropTypes.string,
    withSubHeader: PropTypes.bool,
    subHeaderTitle: PropTypes.string,
    subHeaderSubTitle: PropTypes.string,
    subHeaderAfterSubTitle: PropTypes.string,
    subHeaderDescription: PropTypes.string,
    onClose: PropTypes.func,
    onScroll: PropTypes.func,
    renderSubHeaderRightComponent: PropTypes.func,
  }),
  topUpProps: PropTypes.shape({
    toggleModal: PropTypes.func,
    onTopUpButtonPress: PropTypes.func,
  }),
  renderTopUp: PropTypes.func,
  onRefresh: PropTypes.func,
  lastUpdateTime: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.number,
    PropTypes.string,
  ]),
  isScrollEnabled: PropTypes.bool,
  withTabsScroll: PropTypes.bool,

  // DEPRECATEME: since [Release 22]
  withPageBanner: PropTypes.bool,
  pageBannerProps: PropTypes.shape({
    backgroundColors: PropTypes.array,
    title: PropTypes.string,
    description: PropTypes.string,
    primaryButtonTitle: PropTypes.string,
    secondaryButtonTitle: PropTypes.string,
    onPrimaryButtonPress: PropTypes.func,
    onSecondaryButtonPress: PropTypes.func,
    withSecondaryButton: PropTypes.bool,
  }),
  autoTopUpBannerProps: PropTypes.shape({
    backgroundColors: PropTypes.array,
    title: PropTypes.string,
    description: PropTypes.string,
    primaryButtonTitle: PropTypes.string,
    onPrimaryButtonPress: PropTypes.func,
  }),
  headerShimmerConfig: PropTypes.arrayOf(
    PropTypes.shape({
      main: PropTypes.func,
    }),
  ),
  headerShimmerPlaceholderConfig: PropTypes.shape({
    autoRun: PropTypes.bool,
    duration: PropTypes.number,
    delay: PropTypes.number,
  }),

  // DEPRECATEME: since [Release 21]
  customTabs: PropTypes.arrayOf({
    index: PropTypes.number,
    key: PropTypes.string.isRequired,
    tab_key: PropTypes.string.isRequired,
    renderTabContent: PropTypes.func.isRequired,
    platform: PropTypes.oneOf('android', 'ios'),
  }),
  balanceProps: PropTypes.shape({
    withCategoories: PropTypes.bool,
    images: PropTypes.object,
    balanceData: PropTypes.array,
    isLoading: PropTypes.bool,
  }),
  myPlanProps: PropTypes.shape({
    addExtraPlanData: PropTypes.object,
    onPressAddConfirmation: PropTypes.func,
    withUpgradePlanCTA: PropTypes.bool,
    withUsagePercentage: PropTypes.bool,
    isMyPlanLoading: PropTypes.bool,
    planData: PropTypes.object,
    forceOpenModal: PropTypes.shape({
      force: PropTypes.bool,
      key: PropTypes.string,
      onModalVisibilityChange: PropTypes.func,
    }),
    onPressUpgradePlan: PropTypes.func,
  }),
  devicesProps: PropTypes.shape({
    CurrentDeviceData: PropTypes.object,
    onPressUpgradenow: PropTypes.func,
    isLoading: PropTypes.bool,
  }),
  addOnsProps: PropTypes.shape({
    isMonthView: PropTypes.bool,
    currentPlan: PropTypes.object,
    handleNavigateToAddonsShop: PropTypes.func,
    data: PropTypes.array,
    inlineContentData: PropTypes.object,
    isInlineContentEnabled: PropTypes.bool,
    images: PropTypes.object,
    addOnsListIcon: PropTypes.object,
    addOnsTimelineIcon: PropTypes.object,
    onItemPress: PropTypes.func,
    onInlineContentPress: PropTypes.func,
    isLoading: PropTypes.bool,
  }),
  payMTabsExclude: PropTypes.array,
  payGTabsExclude: PropTypes.array,
  isHeaderLoading: PropTypes.bool,
  /* End deprecation */
};

export default withTheme(ProductsAndServices);
